import InternalLink from "@src/app/components/Elements/Typography/InternalLink/InternalLink";
import { getStoryBookPaginationURL } from "@src/app/helper/storybook";
import cx from "classnames";
import { type ReactElement, ReactNode } from "react";

import styles from "./Pagination.module.css";

type Props = Readonly<{
  isInternalLink?: boolean;
  displayText: ReactNode;
  pageLink?: string;
  isActive?: boolean;
  isDisabled?: boolean;
  hasNoBorder?: boolean;
  isStoryBook?: boolean;
  testId?: string;
}>;

export default function PaginationButton({
  displayText,
  pageLink,
  isActive,
  isDisabled,
  hasNoBorder,
  isStoryBook,
  isInternalLink,
  testId,
}: Props): ReactElement {
  return (
    <li
      data-testid={testId}
      className={cx(
        styles.pagerItem,
        isActive && styles.active,
        isDisabled && styles.disabled,
        hasNoBorder && styles.ellipsis,
      )}
    >
      {isInternalLink ? (
        <InternalLink
          className={cx(hasNoBorder && styles.ellipsis)}
          to={pageLink || "/"}
        >
          {displayText}
        </InternalLink>
      ) : (
        <a
          className={cx(hasNoBorder && styles.ellipsis)}
          href={
            isStoryBook && pageLink
              ? getStoryBookPaginationURL(pageLink)
              : pageLink
          }
        >
          {displayText}
        </a>
      )}
    </li>
  );
}
